import {Component, Input, OnInit} from '@angular/core';
import {CallsQuotaApiService} from '../../../../services/api/settings/routing/calls-quota/calls-quota-api.service';

@Component({
  selector: 'calls-quota-configuration',
  templateUrl: './calls-quota-configuration.component.html',
  styleUrls: ['./calls-quota-configuration.component.scss']
})
export class CallsQuotaConfigurationComponent implements OnInit {

  @Input() isUnauthorized: boolean;
  callsQuotasConfiguration: any = {};

  constructor(private callsQuotaApiService: CallsQuotaApiService) { }

  ngOnInit(): void {
    this.callsQuotaApiService.getCallsQuotasConfiguration().subscribe(cacProfilesConfiguration => {
      this.callsQuotasConfiguration = cacProfilesConfiguration;
    });
  }

  submit(): void {
    this.callsQuotaApiService.editCallsQuotasConfiguration(this.callsQuotasConfiguration).subscribe(() => {
    });
  }

}
